/* =====================================================
   REFURBCOFFEE - THEME JS v1.0
   Standalone: pub/sub, Cart API, cart drawer,
   product form, variant picker, quantity input,
   gallery, accordion, predictive search
   ===================================================== */

/* -------- PUB/SUB (replaces Dawn's pubsub.js) -------- */
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  quantityUpdate: 'quantity-update',
  searchUpdate: 'search-update'
};

let subscribers = {};

function subscribe(event, callback) {
  if (!subscribers[event]) subscribers[event] = [];
  subscribers[event].push(callback);
  return function unsubscribe() {
    subscribers[event] = subscribers[event].filter(function(cb) { return cb !== callback; });
  };
}

function publish(event, data) {
  if (!subscribers[event]) return;
  subscribers[event].forEach(function(callback) {
    callback(data);
  });
}

/* -------- CART API -------- */
const RCCart = {
  routes: {
    get: function() { return (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js'; },
    add: function() { return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js'; },
    change: function() { return (window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js'; },
    update: function() { return (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js'; }
  },

  getState: function() {
    return fetch(this.routes.get(), { headers: { 'Content-Type': 'application/json' } })
      .then(function(r) { return r.json(); });
  },

  add: function(items) {
    return fetch(this.routes.add(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: Array.isArray(items) ? items : [items] })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(e) { throw e; });
      return r.json();
    })
    .then(function(data) {
      publish(PUB_SUB_EVENTS.cartUpdate, data);
      return data;
    });
  },

  change: function(line, quantity) {
    return fetch(this.routes.change(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(e) { throw e; });
      return r.json();
    })
    .then(function(data) {
      publish(PUB_SUB_EVENTS.cartUpdate, data);
      return data;
    });
  },

  update: function(updates) {
    return fetch(this.routes.update(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(e) { throw e; });
      return r.json();
    })
    .then(function(data) {
      publish(PUB_SUB_EVENTS.cartUpdate, data);
      return data;
    });
  }
};

/* Make globally available */
window.RCCart = RCCart;
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
window.subscribe = subscribe;
window.publish = publish;

/* -------- CART DRAWER -------- */
const RCCartDrawer = {
  drawer: null,
  overlay: null,
  body: null,

  init: function() {
    this.drawer = document.getElementById('rc-cart-drawer');
    if (!this.drawer) return;

    this.overlay = this.drawer.querySelector('.rc-cart-drawer__overlay');
    this.body = this.drawer.querySelector('.rc-cart-drawer__body');

    var self = this;

    /* Close button */
    var closeBtn = this.drawer.querySelector('.rc-cart-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', function() { self.close(); });

    /* Overlay click */
    if (this.overlay) this.overlay.addEventListener('click', function() { self.close(); });

    /* ESC key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && self.isOpen()) self.close();
    });

    /* Listen for cart updates */
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      self.refresh();
    });

    /* Delegate: quantity changes inside drawer */
    this.drawer.addEventListener('click', function(e) {
      var minusBtn = e.target.closest('[data-cart-minus]');
      var plusBtn = e.target.closest('[data-cart-plus]');
      var removeBtn = e.target.closest('[data-cart-remove]');

      if (minusBtn) {
        e.preventDefault();
        var line = parseInt(minusBtn.dataset.cartMinus, 10);
        var input = self.drawer.querySelector('[data-cart-qty-input="' + line + '"]');
        var qty = input ? parseInt(input.value, 10) : 1;
        if (qty > 1) RCCart.change(line, qty - 1);
        else RCCart.change(line, 0);
      }

      if (plusBtn) {
        e.preventDefault();
        var line2 = parseInt(plusBtn.dataset.cartPlus, 10);
        var input2 = self.drawer.querySelector('[data-cart-qty-input="' + line2 + '"]');
        var qty2 = input2 ? parseInt(input2.value, 10) : 1;
        RCCart.change(line2, qty2 + 1);
      }

      if (removeBtn) {
        e.preventDefault();
        var line3 = parseInt(removeBtn.dataset.cartRemove, 10);
        RCCart.change(line3, 0);
      }
    });
  },

  isOpen: function() {
    return this.drawer && this.drawer.classList.contains('open');
  },

  open: function() {
    if (!this.drawer) return;
    this.drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.refresh();
  },

  close: function() {
    if (!this.drawer) return;
    this.drawer.classList.remove('open');
    document.body.style.overflow = '';
  },

  refresh: function() {
    if (!this.drawer) return;
    var self = this;
    var panel = this.drawer.querySelector('.rc-cart-drawer__panel');
    if (!panel) return;

    /* Use Section Rendering API for AJAX update */
    var sectionId = this.drawer.dataset.sectionId;
    if (sectionId) {
      fetch('/?section_id=' + sectionId)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var newBody = tmp.querySelector('.rc-cart-drawer__body');
          var newFooter = tmp.querySelector('.rc-cart-drawer__footer');

          /* Update body */
          if (newBody && self.body) self.body.innerHTML = newBody.innerHTML;

          /* Update or create/remove footer */
          var currentFooter = panel.querySelector('.rc-cart-drawer__footer');
          if (newFooter) {
            if (currentFooter) {
              currentFooter.innerHTML = newFooter.innerHTML;
            } else {
              panel.appendChild(newFooter);
            }
          } else if (currentFooter) {
            currentFooter.remove();
          }

          /* Update header count */
          var newTitle = tmp.querySelector('.rc-cart-drawer__title');
          var currentTitle = panel.querySelector('.rc-cart-drawer__title');
          if (newTitle && currentTitle) currentTitle.textContent = newTitle.textContent;
        })
        .catch(function() {});
    }
  }
};

/* -------- PRODUCT FORM (add-to-cart) -------- */
function initProductForms() {
  document.querySelectorAll('form[data-rc-product-form]').forEach(function(form) {
    if (form._rcInit) return;
    form._rcInit = true;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn || submitBtn.disabled) return;

      /* Show loading state */
      var originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="rc-spinner"></span>';

      var formData = new FormData(form);
      var items = [{
        id: parseInt(formData.get('id'), 10),
        quantity: parseInt(formData.get('quantity') || 1, 10)
      }];

      RCCart.add(items)
        .then(function() {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;

          /* Open cart drawer if drawer mode */
          if (RCCartDrawer.drawer) {
            RCCartDrawer.open();
          }
        })
        .catch(function(err) {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          var msg = err.description || err.message || 'Er ging iets mis.';
          publish(PUB_SUB_EVENTS.cartError, { message: msg });
          showNotification(msg, 'error');
        });
    });
  });
}

/* -------- VARIANT PICKER -------- */
function initVariantPickers() {
  document.querySelectorAll('[data-rc-variant-picker]').forEach(function(picker) {
    if (picker._rcInit) return;
    picker._rcInit = true;

    var productJson = picker.dataset.rcVariantPicker;
    var product;
    try { product = JSON.parse(productJson); } catch(e) { return; }

    var form = picker.closest('form[data-rc-product-form]') || picker.closest('form');
    var variantIdInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = picker.closest('.rc-product__info') ?
      picker.closest('.rc-product__info').querySelector('[data-rc-price]') : null;

    picker.addEventListener('change', function(e) {
      if (!e.target.matches('input[type="radio"]')) return;

      /* Gather selected options */
      var selectedOptions = [];
      picker.querySelectorAll('fieldset').forEach(function(fieldset) {
        var checked = fieldset.querySelector('input:checked');
        if (checked) selectedOptions.push(checked.value);
      });

      /* Find matching variant */
      var variant = product.variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      });

      if (variant) {
        /* Update hidden input */
        if (variantIdInput) variantIdInput.value = variant.id;

        /* Update URL */
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        /* Update price */
        if (priceEl) updatePriceDisplay(priceEl, variant);

        /* Update button state */
        var submitBtn = form ? form.querySelector('[type="submit"]') : null;
        if (submitBtn) {
          if (!variant.available) {
            submitBtn.disabled = true;
            submitBtn.textContent = window.variantStrings && window.variantStrings.soldOut ?
              window.variantStrings.soldOut : 'Uitverkocht';
          } else {
            submitBtn.disabled = false;
            submitBtn.textContent = window.variantStrings && window.variantStrings.addToCart ?
              window.variantStrings.addToCart : 'In winkelwagen';
          }
        }

        publish(PUB_SUB_EVENTS.variantChange, { variant: variant });
      }
    });
  });
}

function updatePriceDisplay(container, variant) {
  if (!container) return;
  var regular = container.querySelector('.rc-price__regular');
  var compare = container.querySelector('.rc-price__compare');

  if (regular) regular.textContent = formatMoney(variant.price);

  if (compare) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compare.textContent = formatMoney(variant.compare_at_price);
      compare.style.display = '';
      container.classList.add('rc-price--on-sale');
    } else {
      compare.textContent = '';
      compare.style.display = 'none';
      container.classList.remove('rc-price--on-sale');
    }
  }
}

function formatMoney(cents) {
  if (typeof cents === 'string') cents = parseInt(cents, 10);
  var amount = (cents / 100).toFixed(2).replace('.', ',');
  return '\u20AC' + amount;
}

/* -------- QUANTITY INPUT -------- */
function initQuantityInputs() {
  document.addEventListener('click', function(e) {
    var minus = e.target.closest('[data-rc-qty-minus]');
    var plus = e.target.closest('[data-rc-qty-plus]');

    if (minus) {
      e.preventDefault();
      var wrap = minus.closest('.rc-qty');
      var input = wrap ? wrap.querySelector('.rc-qty__input') : null;
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        if (val > min) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    if (plus) {
      e.preventDefault();
      var wrap2 = plus.closest('.rc-qty');
      var input2 = wrap2 ? wrap2.querySelector('.rc-qty__input') : null;
      if (input2) {
        var val2 = parseInt(input2.value, 10) || 1;
        var max = parseInt(input2.max, 10) || 99;
        if (val2 < max) {
          input2.value = val2 + 1;
          input2.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  });
}

/* -------- PRODUCT GALLERY -------- */
function initProductGallery() {
  document.querySelectorAll('.rc-gallery').forEach(function(gallery) {
    if (gallery._rcInit) return;
    gallery._rcInit = true;

    var mainImg = gallery.querySelector('.rc-gallery__main img');
    var thumbs = gallery.querySelectorAll('.rc-gallery__thumb');

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.dataset.full || thumb.querySelector('img').src;
        var srcset = thumb.dataset.srcset || '';
        var alt = thumb.dataset.alt || '';

        if (mainImg) {
          mainImg.src = src;
          if (srcset) mainImg.srcset = srcset;
          if (alt) mainImg.alt = alt;
        }

        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });

    /* Variant change → update gallery */
    subscribe(PUB_SUB_EVENTS.variantChange, function(data) {
      if (data.variant && data.variant.featured_image) {
        var img = data.variant.featured_image;
        if (mainImg) {
          mainImg.src = img.src;
          mainImg.alt = img.alt || '';
        }
      }
    });
  });
}

/* -------- ACCORDION (native <details>, no JS required) -------- */
function initAccordions() {
  /* Kept as no-op for backwards compat with main init call */
}

/* -------- NOTIFICATION -------- */
function showNotification(message, type) {
  var existing = document.querySelector('.rc-notification');
  if (existing) existing.remove();

  var el = document.createElement('div');
  el.className = 'rc-notification';
  if (type === 'error') el.style.background = '#D32F2F';
  el.textContent = message;
  document.body.appendChild(el);

  requestAnimationFrame(function() {
    el.classList.add('show');
  });

  setTimeout(function() {
    el.classList.remove('show');
    setTimeout(function() { el.remove(); }, 400);
  }, 3000);
}

/* -------- PREDICTIVE SEARCH -------- */
function initPredictiveSearch() {
  document.querySelectorAll('.rc-search').forEach(function(searchWrap) {
    if (searchWrap._rcInit) return;
    searchWrap._rcInit = true;

    var input = searchWrap.querySelector('.rc-search__input');
    var results = searchWrap.querySelector('.rc-search__results');
    if (!input || !results) return;

    var debounceTimer;

    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var query = input.value.trim();

      if (query.length < 2) {
        results.classList.remove('open');
        results.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function() {
        var searchUrl = window.routes && window.routes.predictive_search_url ?
          window.routes.predictive_search_url : '/search/suggest';

        fetch(searchUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&section_id=rc-predictive-search')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var newResults = tmp.querySelector('.rc-search__results-inner');
            if (newResults) {
              results.innerHTML = newResults.innerHTML;
              results.classList.add('open');
            } else if (html.trim()) {
              results.innerHTML = html;
              results.classList.add('open');
            }
          })
          .catch(function() {});
      }, 300);
    });

    /* Close on outside click */
    document.addEventListener('click', function(e) {
      if (!searchWrap.contains(e.target)) {
        results.classList.remove('open');
      }
    });
  });
}

/* -------- COLLECTION: SORT & FILTER -------- */
function initCollectionFilters() {
  document.querySelectorAll('[data-rc-sort]').forEach(function(select) {
    if (select._rcInit) return;
    select._rcInit = true;

    select.addEventListener('change', function() {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', select.value);
      window.location = url.toString();
    });
  });
}

/* -------- INIT -------- */
function rcInit() {
  RCCartDrawer.init();
  initProductForms();
  initVariantPickers();
  initQuantityInputs();
  initProductGallery();
  initAccordions();
  initPredictiveSearch();
  initCollectionFilters();
}

/* Run on DOM ready */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', rcInit);
} else {
  rcInit();
}

/* Re-init on Shopify section load (Theme Editor) */
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    initProductForms();
    initVariantPickers();
    initProductGallery();
    initPredictiveSearch();
    initCollectionFilters();
  });
}
